<template>
  <section id="navBarKanban">
    <nav class="navbar navbar-light bg-light">
      <div class="navbar-tulisanicon">
        <p class="tulisanK">K</p>

        <!-- <p class="app-title" style="margin-left:10px">{{organizationName}}</p> -->
        <div class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdownMenuLink"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >{{organizationName}}</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" style="min-width:50px">
            <div class="dropdown-item" v-on:click="addOrganizationPage()">Add Org.</div>
            <div class="dropdown-item" v-on:click="deleteOrganization()">Delete Org.</div>
          </div>
        </div>
      </div>



      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" href="#">
            {{userEmail}}
            <span class="sr-only">(current)</span>
          </a>
        </li>

        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdownMenuLink"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >Organization List</a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <div v-for="organization in pisahinOrganization" :key="organization.organizationId">
              <div
                class="dropdown-item"
                v-on:click="organizationFinder(organization.organizationId)"
              >{{organization.name}}</div>
            </div>
          </div>
        </li>

        <!-- <li class="nav-item active"> -->

        <!-- </li> -->
      </ul>
      <button class="button-logout" v-on:click="logout">
        Log Out
        <span class="sr-only">(current)</span>
      </button>
    </nav>
  </section>
</template>

<script>
export default {
  name: "navBar",
  props: ["organizationData"],
  data() {
    return {
      organizationId: [],
      userEmail: localStorage.userEmail,
      organizationName: localStorage.organizationName
    };
  },
  methods: {
    logout() {
      this.$emit("logout");
    },

    organizationFinder(params) {
      let payload = {
        id: params
      };
      this.$emit("organizationFinder", payload);
      console.log(params, `dari Navbar`);
    },
    addOrganizationPage(){
      this.$emit('addOrganizationPage')
    },
    deleteOrganization(){
      this.$emit('deleteOrganization')
    }
  },
  computed: {
    pisahinOrganization() {
      let olahanData = [];
      for (let i = 0; i < this.organizationData.length; i++) {
        olahanData.push(this.organizationData[i].organization);
      }
      return olahanData;
      //   console.log(this.organizationId);
    }
  }
};
</script>

<style>
</style>